import { Checkbox } from '@/components/form/Checkbox';

export function ExportSectionHeader({
  label,
  selectAll,
  onToggleSelectAll,
}: {
  label: string;
  selectAll: boolean;
  onToggleSelectAll: (selectAll: boolean) => void;
}) {
  return (
    <div
      data-testid="export-section-header"
      className="bg-chariot-background-secondary flex items-center justify-between rounded-lg px-4 py-3"
    >
      <Checkbox
        name={`select-all-${label}`}
        label="Select All"
        value={selectAll ? 'true' : 'false'}
        onChange={() => {
          onToggleSelectAll(!selectAll);
        }}
        showTick={true}
      />
      <h2 className="text-md font-semibold">{label}</h2>
    </div>
  );
}
